<div class="side-nav-mob">
    <div style="    width: 300px;
    height: 20000px;

    overflow: hidden;
    background-color: dimgrey;">

        <mat-accordion *ngIf="menuTree != null">

            <mat-expansion-panel hideToggle *ngFor="let c of menuTree.children">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <img class="cat-icon" src="assets/icons_/{{c.id}}.png"> {{c.name}}
                    </mat-panel-title>
                    <i class="fa fa-caret-right pull-right"></i>
                </mat-expansion-panel-header>

                <div *ngIf="c.children.length > 0">
                    <ul>

                        <li *ngFor="let sc of c.children" (click)="goToProductBrowserPage(sc.id)"><a> {{sc.name}}</a>
                        </li>
                    </ul>
                </div>

            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div>
        <div style="width: 100%;  z-index: 10000;" class="pl-5 pr-2">
            <button type="button" mat-button><i (click)="sideBarService.toggle()" class="fa fa-times-circle" style="font-size: 30px;"></i></button>
        </div>
    </div>
</div>
